<template>
  <v-layout row align-center>
    <div class="font-weight-bold mr-2">
      {{ section.name.toUpperCase() }}
      <v-chip small v-if="laterSubmissionDate(section) && active === 0">
        {{
          $vuetify.breakpoint.xsOnly
            ? 'Updated '
            : 'Additional submission on  '
        }}{{ laterSubmissionDate(section) }}
      </v-chip>
      <v-chip small v-if="sectionNotes(section).length > 0">
        {{ sectionNotes(section).length }} Note{{
          sectionNotes(section).length > 1 ? 's' : ''
        }}
      </v-chip>
      <v-chip
        small
        v-if="
          currentQuestionnaire.engagement_letter_revision_date &&
            section === 'Engagement Letter'
        "
        >Last Revised
        {{
          moment(currentQuestionnaire.engagement_letter_revision_date).format(
            'll',
          )
        }}</v-chip
      >
    </div>
    <v-spacer />

    <v-chip
      small
      color="warning"
      v-if="matchSection(section).key === 'agreement_signature' && !isSigned"
    >
      {{
        currentQuestionnaire.all_owner_signature_required
          ? 'Not All Signed'
          : 'Unsigned'
      }}
      <template v-if="currentQuestionnaire.all_owner_signature_required"
        >({{
          currentQuestionnaire.engagement_signature.filter(e => e.signature)
            .length
        }}/{{ currentQuestionnaire.engagement_signatures.length }})</template
      >
    </v-chip>
    <v-chip
      small
      color="warning"
      v-else-if="
        !sectionCompleted(currentQuestionnaire, section) &&
          this.sectionKey(section) === 'questionnaire'
      "
    >
      {{ $vuetify.breakpoint.xsOnly ? '' : 'Incomplete ' }}({{
        finishedQuestions(section)
      }}/{{ totalQuestions(section) }})
    </v-chip>
    <v-chip
      small
      color="warning"
      v-else-if="!sectionCompleted(currentQuestionnaire, section)"
    >
      Incomplete
    </v-chip>
    <v-chip
      small
      color="success"
      class="white--text"
      v-else-if="this.sectionKey(section) === 'questionnaire'"
    >
      {{ $vuetify.breakpoint.xsOnly ? '' : 'Completed ' }} ({{
        finishedQuestions(section)
      }}/{{ totalQuestions(section) }})
    </v-chip>
    <v-chip small color="success" class="white--text" v-else>
      Completed
    </v-chip>
  </v-layout>
</template>
<script>
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import { sectionTypes } from '@/constants/variables';
import QuestionnaireMixin from '../mixins/QuestionnaireMixin';

export default {
  name: 'QuestionnaireSectionHeader',
  mixins: [QuestionnaireMixin],
  props: {
    section: {
      required: true,
      type: Object,
    },
    currentQuestionnaire: {
      required: true,
      type: Object,
    },
    active: {
      required: true,
      type: Number,
    },
  },

  data() {
    return {
      sectionTypes,
    };
  },

  computed: {
    isSigned() {
      return (
        this.currentQuestionnaire.engagement_signature.filter(e => e.signature)
          .length === this.currentQuestionnaire.engagement_signatures.length
      );
    },
  },
  methods: {
    isEmpty,
    moment,
    sectionNotes(section) {
      return section.questionnaire_questions
        .map(q => {
          return this.filteredComments(q);
        })
        .flatten();
    },
    finishedQuestions(section) {
      return this.filteredSectionQuestionsToBeAnswered(
        this.currentQuestionnaire,
        section,
      ).filter(q => this.questionAnswered(q)).length;
    },
    totalQuestions(section) {
      return this.filteredSectionQuestionsToBeAnswered(
        this.currentQuestionnaire,
        section,
      ).length;
    },
    laterSubmissionDate(section) {
      let laterSubmissions = this.currentQuestionnaire.questionnaire_questions.filter(
        q => q.section_id === section.id && q.text.includes(' [Provided '),
      );
      if (!isEmpty(laterSubmissions)) {
        return moment
          .max(
            ...laterSubmissions.map(q =>
              moment(q.text.match(/ \[Provided ([0-9\/]+)]/)[1]),
            ),
          )
          .format('MM/DD/Y');
      } else {
        return false;
      }
    },
  },
  created() {},
};
</script>
<style lang="postcss" scoped>
.bordered {
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #d3d3d3;
}
.questionnaire-arrow {
  color: #abb3c0 !important;
}
.outlined {
  border: solid 0.2px rgba(9, 30, 66, 0.06) !important;
}
.light-background {
  background-color: #f5f8ff;
  overflow: hidden;
}
</style>
